import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MetaDecorator } from '../helpers/metaDecorator';
import Typography from '@material-ui/core/Typography';
import DoubleArrowRoundedIcon from '@material-ui/icons/DoubleArrowRounded';
import Container from '@material-ui/core/Container';
import AspectRatioRoundedIcon from '@material-ui/icons/AspectRatioRounded';
import AlternateEmailRoundedIcon from '@material-ui/icons/AlternateEmailRounded';
import StorageRoundedIcon from '@material-ui/icons/StorageRounded';
import { CanonicalLink } from '../helpers/constants';

interface Props { }

const useStyles = makeStyles({
    arrowParagraphs: {
        fontSize: "0.7rem"
    },
    header: {
        fontFamily: 'Sansita Swashed',
        fontWeight: 500,
    },
    root: {
        marginTop: "50px"
    },
});

export const Policy: React.FC<Props> = () => {

    const classes = useStyles();

    return (
        <div>
            <MetaDecorator
                title="Rock Gawęda- polityka prywatności"
                description="Polityka prywatności strony Rockgaweda.pl"
                canonicalLink={CanonicalLink.policy} />
            <Container maxWidth="md" className={classes.root}>
                <br />
                <Typography className={classes.header} component="h5" variant="h5" color="textPrimary" align="center">
                    Polityka prywatności strony
             </Typography>
                <div>
                    <br />
                    <React.Fragment>
                        <Typography className={classes.header} align="left" component="h6" variant="h6" color="textPrimary">
                            <DoubleArrowRoundedIcon className={classes.arrowParagraphs} /> Kim jesteśmy?
                            </Typography>
                        <p>
                            Adres naszej strony internetowej to: <a href="/">rockgaweda.pl</a>. Używamy technologii, takich jak pliki cookie, w celu umożliwienia zbierania informacji o sposobie korzystania ze strony internetowej i jesteśmy jednocześnie Administratorem Twoich Danych Osobowych.
                            </p>
                    </React.Fragment>

                    <br />
                    <br />
                    <React.Fragment>
                        <Typography className={classes.header} component="h6" variant="h6" color="textPrimary">
                            <DoubleArrowRoundedIcon className={classes.arrowParagraphs} /> Jakie dane zbieramy i po co są nam potrzebne?
                            </Typography>
                        <div>
                            <br />
                            <Typography variant="subtitle2" color="textPrimary">
                                <StorageRoundedIcon className={classes.arrowParagraphs} /> <b>Ciasteczka:</b> <br />  Pliki cookies stanowią dane informatyczne, przechowywane na urządzeniu końcowym użytkownika. Wykorzystywane są w celu umożliwienia zbierania informacji o sposobie korzystania ze strony internetowej. Użytkownik zawsze ma możliwość usunięcia plików cookies i/lub zablokowania ich zapamiętywania. Ustawienia takie oferuje każda przeglądarka internetowa.
                            </Typography>
                            <br />
                            <Typography variant="subtitle2" color="textPrimary">
                                <AspectRatioRoundedIcon className={classes.arrowParagraphs} /> <b>Rozdzielczość ekranu:</b>  <br />    Dane te są wykorzystywane do optymalizacji działania strony.
                            </Typography>
                            <br />
                            <Typography variant="subtitle2" color="textPrimary">
                                <AlternateEmailRoundedIcon className={classes.arrowParagraphs} /> <b>Opcjonalny adres email:</b> <br />  Może być podawany opcjonalnie gdy użytkownik dodaje nową historię do bazy danych. Wykorzystywany jest w celach kontaktowych, dotyczącej dodanej historii przez autora.
                            </Typography>

                            <p>
                                Podanie dowolnych danych osobowych jest zawsze dobrowolne. W każdej chwili masz prawo do aktualizacji lub całkowitego usunięcia swoich danych osobowych. W tym celu należy skontaktować się z administratorem strony <a href="mailto:kontakt.rockgaweda@gmail.com">kontakt.rockgaweda@gmail.com</a>.
                            </p>
                        </div>
                    </React.Fragment>

                </div>
                <div>
                </div>
            </Container>
        </div>

    );
};